export default {
  impact: 'Impact',
  repartition: 'Répartition',
  fullProperty: 'DÉCÈS - PLEINE PROPRIÉTÉ',
  onlyWall: 'DÉCÈS - NUE PROPRIÉTÉ',
  usufruit: 'DÉCÈS - USUFRUIT',
  donation: 'DONATION',
  totalCost: 'COÛT TOTAL DE LA TRANSMISSION',
  death: 'DÉCÈS',
  legends: {
    actual: 'Situation actuelle',
    simulation: 'Simulation',
  },
  help: {
    currentSituation: 'transmission currentSituation help',
    simulation: 'transmission simulation help'
  }
}
